module.exports = __webpack_public_path__ + "img/1509271413.7e81bcb5.jpg";